module.exports = __webpack_public_path__ + "images/clover-759ab3f04f5262b5b0281aa099756439.png";